const prlx = () => {
    let prlxItems = document.querySelectorAll('.js-prlx');

    if (prlxItems.length) {
        prlxItems.forEach(function(prlxItem) {
            let start = "top bottom";
            let end = "bottom 200px";

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: prlxItem,
                    start: start,
                    end: end,
                    scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
                    markers: false, // Set to true to add markers to UI to debug.
                }
            });

            tl.fromTo(prlxItem, {
                y: 0
            }, {
                y: -100,
                ease: "none",
                duration: 2,
            });
        });
    }

    let prlxImagesLarge = document.querySelectorAll('.js-prlx-image-large');

    if (prlxImagesLarge.length) {
        prlxImagesLarge.forEach(function(prlxItem) {
            let start = "top bottom";
            let end = "bottom 200px";

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: prlxItem,
                    start: start,
                    end: end,
                    scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
                    markers: false, // Set to true to add markers to UI to debug.
                }
            });

            tl.fromTo(prlxItem, {
                y: 0
            }, {
                y: "-20%",
                ease: "none",
                duration: 2,
            });
        });
    }

    let prlxImages = document.querySelectorAll('.js-prlx-image');

    if (prlxImages.length) {
        prlxImages.forEach(function(prlxItem) {
            let start = "top bottom";
            let end = "bottom 200px";

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: prlxItem,
                    start: start,
                    end: end,
                    scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
                    markers: false, // Set to true to add markers to UI to debug.
                }
            });

            tl.fromTo(prlxItem, {
                y: 0
            }, {
                y: "-10%",
                ease: "none",
                duration: 2,
            });
        });
    }
}

prlx();